module.exports = __webpack_public_path__ + "img/blog6-logo-4.35cc35d1.webp";